import { render, staticRenderFns } from "./BatchOrderResubmit.vue?vue&type=template&id=4d1e9e38&scoped=true&"
import script from "./BatchOrderResubmit.vue?vue&type=script&lang=js&"
export * from "./BatchOrderResubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1e9e38",
  null
  
)

export default component.exports